// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import '../static/css/com.css'
import {getsign} from '../static/js/getsign.js'
//import VueResource from 'vue-resource'
/*使用VueResource插件*/
import ElementUi from 'element-ui'
import './element-variables.scss'
import './fotoo.scss'
import COM from './util/comfun'
// import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUi)
Vue.prototype.$getsign = getsign;
//Vue.use(VueResource)
Vue.config.productionTip = false
Vue.prototype.$http=COM.oldHttp

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js